import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getProductDefaultInfo } from '../../../../utilities/selectors';
import {
  getZlataPriadkaProductDefaultInfo,
  getZlataPriadkaTrueCount,
} from '../../selectors';
import { OrderNrInput } from '../../Product/OrderNrInput';
import { TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
  FlexColCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { CountSetter } from '../../ProductDetail/CountSetter';
import { __ } from 'react-i18n';
import { getSymbolFromCurrency, getImagePath } from '../../../../utilities';

export interface Props {
  product: any;
  theme: any;
  hasMinAmountInfo?: boolean;
  count: string;
  handleCountChange: any;
  isLoggedIn: any;
}

function ModalItemMobile({
  product,
  theme,
  hasMinAmountInfo,
  count,
  handleCountChange,
  isLoggedIn,
}: Props) {
  const { currency } = getProductDefaultInfo(product);
  const {
    unit,
    price,
    priceWithoutVat,
    picture,
  } = getZlataPriadkaProductDefaultInfo(product);
  const step = unit === 'm' ? 0.1 : 1;
  const correctPrice = isLoggedIn ? priceWithoutVat : price;

  return (
    <Wrapper>
      <ImageWrapper>
        <Image
          alt={`Obrázok ku produktu ${product.name}`}
          src={
            picture
              ? getImagePath(
                  process.env.REACT_APP_API_BASE_URL as string,
                  picture,
                  { width: 80, height: 80 },
                )
              : '/images/zlatapriadka/placeholder.svg'
          }
        />
      </ImageWrapper>

      <NameCounterWrapper>
        <NameInputWrapper>
          <Name>{product.name}</Name>
        </NameInputWrapper>
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
          />
          <PriceWrapper>
            <Price>{`${correctPrice} ${getSymbolFromCurrency(
              currency,
            )}`}</Price>
          </PriceWrapper>
        </CountWrapper>
      </NameCounterWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  max-width: ${rem(320)};
  margin: 0 auto;
  padding: ${rem(24)} 0 0;
  justify-content: space-between;

  ${({ theme }) => theme.mediab.s450`
      max-width: initial;
      width: 100%;
      justify-content: space-around;
  `}
`;

const CountWrapper = styled(FlexRow)`
  margin-top: ${rem(8)};
  margin-bottom: ${rem(24)};
  width: max-content;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};
  width: ${rem(80)};
  height: ${rem(80)};

  ${({ theme }) => theme.mediab.s450`
    width: ${rem(80)};
    height: ${rem(80)};
  `}
  ${({ theme }) => theme.mediab.s380`
    width: ${rem(60)};
    height: ${rem(60)};
  `}

  ${({ theme }) => theme.mediab.s320`
    width: ${rem(48)};
    height: ${rem(48)};
  `}
`;

const Image = styled.img`
  width: ${rem(80)};
  height: ${rem(80)};
  max-width: initial;
  object-fit: contain;

  ${({ theme }) => theme.mediab.s450`
    width: ${rem(80)};
    height: ${rem(80)};
  `}

  ${({ theme }) => theme.mediab.s380`
    width: ${rem(60)};
    height: ${rem(60)};
  `}

  ${({ theme }) => theme.mediab.s320`
    width: ${rem(48)};
    height: ${rem(48)};
  `}
`;

const NameInputWrapper = styled(FlexCol)``;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  text-align: left;
  font-weight: 300;
  white-space: nowrap;
  max-width: ${rem(400)};
  transition: color 0.2s;

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  `}
`;

const NameCounterWrapper = styled(FlexColCenterVertical)`
  margin-right: ${rem(16)};
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  margin: ${rem(14)} 0;
`;

const PriceWrapper = styled.div`
  padding: 0 ${rem(16)};
`;

const WithTheme: any = withTheme(ModalItemMobile);
export { WithTheme as ModalItemMobile };
